$(".button[data-modal]").click(function(){
    var _this = $(this);
    $.ajax({
        url: _this.attr("href"),
        beforeSend: function() {
            $("#modal").removeClass("open").find(".content").html('');
            _this.addClass("loading");
        },
        success: function(data){
            $("#modal .content").html(data);

            setTimeout(function() {
                $("#modal").addClass("open");
                $("body").addClass("noscroll");
            }, 300);
        },
        complete: function(){
            setTimeout(function() {
                _this.removeClass("loading");
            }, 300);
        }
    });

    return false;
});

$("body").on("click","#modal a.close", function(){
    $(this).parent().removeClass("open");
    $("body").removeClass("noscroll");

    return false;
});
